import React from 'react'

export type PermissionCallback = (key: string) => boolean | void
export type Permissions = Record<string, boolean>

const Context = React.createContext<PermissionCallback | void>(undefined)

export default Context
